export const INVENTORY_CALENDAR_VIEW = 'inventory-calendar-view'
export const INVENTORY_ROUTE_LEVEL_VIEW = 'inventory-route-level-view'
export const INVENTORY_ALL_ROUTES_REFRESH_DATA = 'inventory-all-routes-refresh-data'
export const INVENTORY_ROUTE_LEVEL_REFRESH_DATA = 'inventory-route-level-refresh-data'
export const REJECTION_REASONS_DATA = 'rejection-reasons-data'